var map = {
	"./ana-intro.mp3": 38,
	"./ashe-intro.mp3": 39,
	"./baptiste-intro.mp3": 40,
	"./bastion-intro.mp3": 41,
	"./brigitte-intro.mp3": 42,
	"./doomfist-intro.mp3": 43,
	"./dvameka-intro.mp3": 44,
	"./echo-intro.mp3": 45,
	"./genji-intro.mp3": 46,
	"./hanzo-intro.mp3": 47,
	"./junkrat-intro.mp3": 48,
	"./lucio-intro.mp3": 49,
	"./mccree-intro.mp3": 50,
	"./mei-intro.mp3": 51,
	"./mercy-intro.mp3": 52,
	"./moira-intro.mp3": 53,
	"./orisa-intro.mp3": 54,
	"./pharah-intro.mp3": 55,
	"./reaper-intro.mp3": 56,
	"./reinhardt-intro.mp3": 57,
	"./roadhog-intro.mp3": 58,
	"./sigma-intro.mp3": 59,
	"./soldier-intro.mp3": 60,
	"./sombra-intro.mp3": 61,
	"./symmetra-intro.mp3": 62,
	"./torbjorn-intro.mp3": 63,
	"./tracer-intro.mp3": 64,
	"./widowmaker-intro.mp3": 65,
	"./winston-intro.mp3": 66,
	"./wreckingball-intro.mp3": 67,
	"./zarya-intro.mp3": 68,
	"./zenyatta-intro.mp3": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;